// extracted by mini-css-extract-plugin
export var parcelRow = "_tc-0";